import { useEffect, useState } from "react";
import { resetAllMealsToShow } from "Redux/slices/selectedMealsSlice";
import { useDispatch } from "react-redux";
import { resetStore } from "Redux/store";
import { useAuthStatus } from "context/OAuth/AuthContext";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_WORDPRESS_URL;
const LOGOUT_API = `${BASE_URL}/wp-json/custom/v1/logout`;

const Logout = () => {
  const [message, setMessage] = useState("Logging you out...👋");
  const [fade, setFade] = useState("opacity-100");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { resetAuthContext } = useAuthStatus();
  useEffect(() => {
    const logoutUser = async () => {
      try {
        dispatch(resetStore());
        // logout();
        const response = await fetch(LOGOUT_API, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (data.status === "success") {
          localStorage.removeItem("access_token");
          localStorage.clear();
          resetAuthContext();
          navigate("/login");
        } else {
          localStorage.removeItem("access_token");
          localStorage.clear();
          resetAuthContext();
          console.error("Unexpected response during logout:", data);
          navigate("/login");
        }
      } catch (error) {
        console.error("Logout failed:", error);
        localStorage.removeItem("access_token");
        localStorage.clear();
        resetAuthContext();
        navigate("/login");
      }
    };

    logoutUser();
  }, []);

  return (
    <div className="h-screen flex flex-col justify-center items-center text-xl font-semibold bg-gradient-to-r from-blue-500 to-purple-500 text-white">
      <div className={`transition-opacity duration-1000 ${fade}`}>
        <p className="text-3xl font-bold animate-pulse">{message}</p>
      </div>
    </div>
  );
};

export default Logout;
